import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const notesPermissionProfiles = {
    EDIT_NOTES: {
        [modes.EDIT]: [roles.OWNER, roles.VENDOR],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.EDIT_NOTES]
    },
    VIEW_NOTES: {
        [modes.EDIT]: [roles.OWNER, roles.VENDOR],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.EDIT_NOTES, permissions.NOTES.VIEW_NOTES]
    },
    DELETE: {
        [modes.EDIT]: [roles.VENDOR],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.DELETE]
    },
    VIEW_BY_CLIENT: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    },
    VIEW_SYSTEM_NOTES: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    },
    VIEW_INTERNAL_TIER_NOTES: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.CLIENT, roles.ACCOUNT_MANAGER, roles.SUPERVISOR, roles.MECHANIC]
    },
    VIEW_VENDOR_NOTES: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.ACCOUNT_MANAGER, roles.SUPERVISOR, roles.VENDOR]
    },
    EDIT_HOT_NOTE: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.NOTES.EDIT_HOT_NOTE],
        [modes.READONLY]: [roles.ADMIN, roles.CLIENT, roles.ACCOUNT_MANAGER, roles.SUPERVISOR, roles.MECHANIC],
        [modes.READONLY_PERMISSION]: [permissions.NOTES.EDIT_NOTES, permissions.NOTES.VIEW_NOTES]
    }
}